import { useCallback } from 'react';

import Particles from 'react-tsparticles';
import { loadFull } from 'tsparticles';

import styles from './Particle.module.scss';

import type { Engine } from 'tsparticles-engine';

export const Particle = () => {
  const particlesInit = useCallback(async (engine: Engine) => {
    // you can initialize the tsParticles instance (engine) here, adding custom shapes or presets
    // this loads the tsparticles package bundle, it's the easiest method for getting everything ready
    // starting from v2 you can add only the features you need reducing the bundle size
    await loadFull(engine);
  }, []);

  return (
    <Particles
      className={styles.root}
      id="tsparticles"
      init={particlesInit}
      options={{
        particles: {
          number: {
            value: 50, //この数値を変更するとホタルの数が増減できる
            density: {
              enable: true,
              value_area: 1602.3971861905397,
            },
          },
          color: {
            value: '#FFDC82', //色
          },
          shape: {
            type: 'circle', //形状はcircleを指定
            stroke: {
              width: 0,
            },
          },
          opacity: {
            value: 1,
            random: true, //透過をランダムに
            anim: {
              enable: true,
              speed: 0.1,
              opacity_min: 0,
              sync: false,
            },
          },
          size: {
            value: 4.005992965476349,
            random: true, //サイズをランダムに
            anim: {
              enable: true,
              speed: 1,
              size_min: 0,
              sync: false,
            },
          },
          line_linked: {
            enable: false,
          },
          move: {
            enable: true,
            speed: 4, //この数値を小さくするとゆっくりな動きになる
            direction: 'top-left',
            random: false, //動きはランダムにしない
            straight: false, //動きをとどめない
            out_mode: 'out', //画面の外に出るように描写
            bounce: false, //跳ね返りなし
            attract: {
              enable: false,
              rotateX: 600,
              rotateY: 600,
            },
          },
        },
        interactivity: {
          detect_on: 'canvas',
          events: {
            onhover: {
              enable: false,
            },
            onclick: {
              enable: false,
            },
            resize: true,
          },
        },
        retina_detect: true,
      }}
    />
  );
};
